export default "__VITE_ASSET__1b658c35__"